export const getFooterItems = (cityAlias: string) => {
  const baseTranslate = 'shared.footer';

  return [
    [
      { name: `${baseTranslate}.doctors`, href: `/${cityAlias}/doctors` },
      { name: `${baseTranslate}.medcenters`, href: `/${cityAlias}/medcenters` },
      { name: `${baseTranslate}.services`, href: `/${cityAlias}/services` },
      { name: `${baseTranslate}.skills`, href: `/${cityAlias}/skills/all` },
      { name: `${baseTranslate}.medcenters_type`, href: `/${cityAlias}/medcenters/types` },
    ],
    [
      { name: `${baseTranslate}.articles`, href: '/posts' },
      { name: `${baseTranslate}.askDoctorQuestion`, href: '/questions' },
      { name: `${baseTranslate}.handbook`, href: '/illnesses' },
      { name: `${baseTranslate}.treatment`, href: `/${cityAlias}/lechenie` },
      { name: `${baseTranslate}.about_project`, href: '/about' },
    ],
    [
      { name: `${baseTranslate}.partnership`, href: '/partnership' },
      { name: `${baseTranslate}.contacts`, href: '/contacts' },
      { name: `${baseTranslate}.legal`, href: '/agreement' },
    ],
  ];
};
